import { render, staticRenderFns } from "./AssetMatchPolicyTab.vue?vue&type=template&id=2ef79f73"
import script from "./AssetMatchPolicyTab.vue?vue&type=script&lang=js"
export * from "./AssetMatchPolicyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports